<template>
    <div id="footer">
        <v-card>
            <v-tabs
                :background-color="theme.headerFooterColor"
                @change="onChange"
                color="teal"
                icons-and-text
                centered
                show-arrows                
            >
<!--                <template v-if="!showCustomLayout || !dynamicFooterMenu.length">-->
<!--                    <v-tab v-for="(item, index) in menu" :key="index" :to="item.link" class="footer-items">-->
<!--                        <div class="footer-item">-->
<!--                            <v-icon :color="theme.footerIconColor">{{ item.icon }}</v-icon>-->
<!--                            <span v-if="showTitles" :style="{ 'color': theme.footerIconColor }">{{ item.title }}</span>-->
<!--                        </div>-->
<!--                    </v-tab>-->
<!--                </template> -->
                <template>
                    <v-tab v-for="(item, index) in menuItems" :key="index" :to="item.link" class="footer-items">
                        <div class="footer-item">
                            <v-icon :color="theme.footerIconColor">{{ item.icon }}</v-icon>
                            <span v-if="true" :style="{ 'color': theme.footerIconColor }">{{ item.title }}</span>
                        </div>
                    </v-tab>
                </template>
                <template v-slot:next>
                    <v-btn text @click="next()" :style="{ 'color': theme.footerIconColor }"><v-icon>mdi-chevron-right</v-icon></v-btn>
                </template>
            </v-tabs>
        </v-card> 
        </div>
</template>

<script>
import CONFIG from '@/constants/config.js';
import {settingsMixin} from "../../utils/settings-mixin";
import { layoutMixin } from '../../utils/layout-mixin';
import { eventMixin } from '../../utils/event-mixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [settingsMixin, layoutMixin, eventMixin],
    props: {
        eventId: {},
        iconColor: {},
    },
    updated() {
        this.assignPseudoElementStyle();
    },

    watch: {
        // Redirects from the plain tasks route to the first custom menu entry. The watcher
        // keeps running on purpose: when entering an event it fires before the checkin has
        // finished, and only a later run delivers links with the real event id.
        dynamicFooterMenu: {
            handler(newValue) {
                if(!this.showCustomLayout || newValue.length < 1){
                    return;
                }
                // until the checkin of the routed event has finished, selectedEventId is unset
                // or stale and the links would point to /event/undefined/...
                if(!this.selectedEventId || String(this.selectedEventId) !== String(this.$route.params.id)){
                    return;
                }
                const pattern = /^\/event\/\d+\/tasks\/?$/;
                if(pattern.test(this.$route.path)){
                    this.$router.push(newValue[0].link);
                }
            },
            immediate: true
        }
    },

    computed: {
        ...mapGetters('events', 
            [
                'getSelectedEventFooterLayout'
            ]
        ),
        menu() {
            let data = [
                { id: 1, title: this.labelInfo, link: `/event/${this.eventId}/info`, icon: 'mdi-information' },
                { id: 2, title: ( ( !this.isSmAndDownDevice && this.menuShouldShowMap ) ? this.labelMap : this.labelTasks ), link: `/event/${this.eventId}/tasks`, icon: 'mdi-star' },
                { id: 4, title: this.labelHighscore, link: `/event/${this.eventId}/highscore`, icon: 'mdi-format-list-numbered' }
            ];
            if ( this.isSmAndDownDevice && this.menuShouldShowMap ) {
                data = this.addMenuItem(data, { id: 3, title: this.labelMap, icon: 'map', url: 'map' }, 'map');
            }
            data = this.addMenuItem(data, CONFIG.FEATURE_IFRAME, 'data');
            data = this.addMenuItem(data, CONFIG.FEATURE_GALLERY, 'gallery');
            data = this.addMenuItem(data, CONFIG.FEATURE_EVIDENCE, 'evidence');
            data = this.addMenuItem(data, CONFIG.FEATURE_DRAWING, 'draw');

            return this._.sortBy(data, ['id']);
        },
        menuItems() {
            if (this.showCustomLayout) {
                let data = this.dynamicFooterMenu;
                data = this.addMenuItem(data, CONFIG.FEATURE_IFRAME, 'data');
                data = this.addMenuItem(data, CONFIG.FEATURE_GALLERY, 'gallery');
                data = this.addMenuItem(data, CONFIG.FEATURE_EVIDENCE, 'evidence');
                data = this.addMenuItem(data, CONFIG.FEATURE_DRAWING, 'draw');
                return data;
            } else {
                return this.menu;
            }
        },
        showTitles() {
            return (this.menuItems.length <= 4 && this.isSmAndDownDevice) || this.menuItems.length <= 6 || this.isMdAndUpDevice;
        },
    },
    data() {
        return {
            icons: [],
            iconColorValue: this.iconColor
        };
    },
    methods: {
        addMenuItem(data, item, routeName) {
            if (this._.isArray(data) && !this._.isEmpty(item) && !this._.isEmpty(item.url)) {
                data.push({
                    id: item.id,
                    title: this.$t(item.title),
                    link: `/event/${this.eventId}/${routeName}`,
                    icon: `mdi-${item.icon}`
                });
            }
            return data;
        },
        onChange() {},
        assignPseudoElementStyle() {
            this.iconColorValue = this.theme.footerIconSelectedColor;
            document.documentElement.style.setProperty('--icon-color', this.iconColorValue);
            document.documentElement.style.setProperty('--arrows-color', this.theme.footerIconColor);
        },

    }
};
</script>


<style lang="scss">
#footer {
    position: sticky;
    bottom: 0px;
    .v-tab--active {
        .v-icon {
            color: var(--icon-color) !important;
        }
        span {
            color: var(--icon-color) !important;
        }
    }

    .v-slide-group__next i,
    .v-slide-group__prev i{
        color: var(--arrows-color) !important;
    }


  
    .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
        display: none;
    }
    .teal--text {
        color: transparent !important;
        caret-color: transparent !important;
    }
    .theme--light.v-card {
        background-color: transparent;
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
        box-shadow: 0px 0px transparent;
        -webkit-box-shadow: 0px 0px transparent;
    }
    .v-slide-group__content {
        a {
        font-size: 12px;
        text-transform: capitalize;
        }
    }
    .v-tabs--icons-and-text > .v-tabs-bar {
         height: 51px;
    }
    .v-tabs--icons-and-text > .v-tabs-bar .v-tab > *:first-child {
        margin-bottom:0px;
    }
    a {
        &.footer-items {
            @media screen and (min-width: 960px) {
                padding: 0px 40px 0px 40px;
            }
            @media screen and (max-width: 1200px) {
                padding: 0px 0px 0px 0px;
            }
            &:first-of-type {
                @media screen and (min-width: 960px) {
                  padding: 0px 35px 0px 5px;
                }
                @media screen and (max-width: 1200px) {
                    padding: 0px 0px 0px 0px;
                }
            }
            .footer-item {
                @media screen and (min-width: 960px) {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
    }

    .v-sheet.v-card {
        border-radius: 0px;
    }
}
</style>
